// extracted by mini-css-extract-plugin
export default {"root":"StyledTextInput_root__GzYza","input":"StyledTextInput_input__uxMs4"};